import i18n from 'i18next'; import { useContext, useEffect, useRef, useState, Fragment } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// import { formatDistanceToNowStrict } from 'date-fns';
import {
  Badge,
  Box,
  IconButton,
  Link,
  Popover,
  Tab,
  Tabs,
  Tooltip,
  Typography,
  Button
} from
  '@material-ui/core';
import BellIcon from '../../icons/Bell';
import DraftsIcon from '@material-ui/icons/Drafts';
import notificationservice from '../../services/notificationservice';
import { ChatContext } from '../../contexts/ChatContext';
import helpers from '../../utils/helpers';
import NotificationList from '../../components/common/notification/NotificationList';
import constants from '../../utils/constants';

// const now = new Date();

// const notifications = [
//   {
//     id: '5e8883f1b51cc1956a5a1ec0',
//     createdAt: subHours(now, 2).getTime(),
//     description: 'Dummy text',
//     title: 'Your order is placed',
//     type: 'order_placed'
//   },
//   {
//     id: '5e8883f7ed1486d665d8be1e',
//     createdAt: subDays(now, 1).getTime(),
//     description: 'You have 32 unread messages',
//     title: 'New message received',
//     type: 'new_message'
//   },
//   {
//     id: '5e8883fca0e8612044248ecf',
//     createdAt: subDays(now, 3).getTime(),
//     description: 'Dummy text',
//     title: 'Your item is shipped',
//     type: 'item_shipped'
//   },
//   {
//     id: '5e88840187f6b09b431bae68',
//     createdAt: subDays(now, 7).getTime(),
//     description: 'You have 32 unread messages',
//     title: 'New message received',
//     type: 'new_message'
//   }
// ];

const tabs = [
  {
    label: 'Genel',
    value: constants.notificationUserType.both,
    badgeColor: 'success'
  },
  {
    label: 'Firma',
    value: constants.notificationUserType.buyer,
    badgeColor: 'secondary'
  },
  {
    label: 'Tedarikçi',
    value: constants.notificationUserType.seller,
    badgeColor: 'warning'
  }];

const NotificationsPopover = () => {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { notifications, setNotifications, unReadedNotificationCount, getUnReadedNotficationCount } = useContext(ChatContext);
  const [skip, setSkip] = useState({
    Buyer: 0,
    Seller: 0,
    Both: 0
  });
  const [isEmpty, setIsEmpty] = useState({
    Buyer: false,
    Seller: false,
    Both: false
  });
  const [loading, setLoading] = useState(false);
  const [currentTab, setCurrentTab] = useState(constants.notificationUserType.both);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleTabsChange = (event, value) => {
    setCurrentTab(value);
  };

  // const getNotifications = () => {
  //   notificationservice.getAllNotification().then((response) => {
  //     if (response) {
  //       response.forEach((f) => {
  //         f.createdAt = helpers.timeDifference(new Date(), new Date(f.createDate));
  //         f.type = f.status ? 'order_placed' : 'new_message';
  //         f.description = f.message;
  //       });
  //       setNotifications(response);
  //     }
  //   });
  // };

  const getNotifications = () => {
    if (isEmpty[currentTab]) {
      return;
    }
    setLoading(true);
    const model = {
      paging: {
        itemsPerPage: 10,
        currentPage: skip[currentTab]
      }
    };
    if (currentTab !== constants.notificationUserType.both || skip[currentTab] > 0) {
      model.filter = {
        userType: Object.values(constants.notificationUserType).findIndex((f) => f === currentTab) + 1
      };
    }
    notificationservice.getNotifications(model).then((response) => {
      if (response) {
        const cloneIsEmpty = { ...isEmpty };
        if (response.data.length === 0) {
          cloneIsEmpty[currentTab] = true;
          setIsEmpty(cloneIsEmpty);
        } else {
          const notifies = [...notifications];
          response.data.forEach((f) => {
            f.createdAt = helpers.timeDifference(new Date(), new Date(f.createDate));
            f.statusType = f.status ? 'order_placed' : 'new_message';
            f.description = f.message;
            try {
              f.jsonData = JSON.parse(f.jsonData);
            } catch (error) {
              f.jsonData = {};
            }
            notifies.push(f);
          });
          setNotifications(notifies);
          cloneIsEmpty[currentTab] = false;
          setIsEmpty(cloneIsEmpty);
        }
      }
      setLoading(false);
    });
  };

  const readNotification = async (notificationId) => {
    const response = await notificationservice.readNotification({ notificationId });
    if (response) {
      getUnReadedNotficationCount();
      const notifies = [...notifications];
      const index = notifies.findIndex((f) => f.id === notificationId);
      notifies[index] = {
        ...notifies[index],
        status: true
      };
      setNotifications(notifies);
    }
  };

  const readAllNotifications = () => {
    notificationservice.readAllNotification().then((response) => {
      if (response || response === '') {
        const notifies = [...notifications];
        notifies.forEach((n) => {
          n.status = true;
        });
        setNotifications(notifies);
        getUnReadedNotficationCount();
      }
    });
  };

  useEffect(() => {
    getNotifications();
  }, [skip]);

  return (
    <>
      <Tooltip title={i18n.t('NotificationsPopover.bildirimler')}>
        <IconButton
          color="inherit"
          ref={anchorRef}
          onClick={handleOpen}
        >

          <Badge
            color="primary"
            badgeContent={unReadedNotificationCount?.total || 0}
          >

            <BellIcon fontSize="small" />
          </Badge>
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={anchorRef.current}
        anchorOrigin={{
          horizontal: 'center',
          vertical: 'bottom'
        }}
        onClose={handleClose}
        open={open}
        PaperProps={{
          sx: { width: 500 }
        }}
        className="tp-notification"
      >

        <Box
          sx={{ p: 2 }}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
        >

          <Typography
            color="textPrimary"
            variant="h6"
          >
            {i18n.t('NotificationsPopover.bildirimler')}

          </Typography>
          {
            unReadedNotificationCount && Object.values(unReadedNotificationCount).some((val) => val > 0)
            && (
              <Button
                onClick={() => {
                  readAllNotifications();
                }}
                startIcon={<DraftsIcon fontSize="small" />}
                variant="contained"
                color="primary"
                size="small"
              >
                {i18n.t('NotificationsPopover.hepsi_okundu_olarak_i\u015Faretle')}

              </Button>
            )

          }
        </Box>
        <Box
          sx={{ pl: 2 }}
        >

          <Link
            color="textPrimary"
            sx={{ cursor: 'pointer' }}
            underline="hover"
            variant="subtitle2"
            component={RouterLink}
            to="/notifications"
          >
            {i18n.t('NotificationsPopover.t\xFCm\xFCn\xFC_g\xF6r')}

          </Link>
        </Box>
        {notifications.length === 0

          ? (
            <Box sx={{ p: 2 }}>
              <Typography
                color="textPrimary"
                variant="subtitle2"
              >
                {i18n.t('NotificationsPopover.\u015Fuan_hi\xE7_bildirim_yok')}

              </Typography>
            </Box>
          )

          : (
            <>
              <Tabs
                indicatorColor="primary"
                onChange={handleTabsChange}
                scrollButtons="auto"
                textColor="primary"
                value={currentTab}
                variant="scrollable"
              >

                {tabs.map((tab) => (
                  <Tab
                    key={tab.value}
                    label={tab.label}
                    value={tab.value}
                    icon={unReadedNotificationCount[tab.value.toLowerCase()] && unReadedNotificationCount[tab.value.toLowerCase()] > 0
                      ? (
                        <Badge
                          badgeContent={unReadedNotificationCount[tab.value.toLowerCase()] || '-'}
                          color={tab.badgeColor}
                        />
                      )

                      : null}
                  />
                ))}
              </Tabs>
              <NotificationList
                isEmpty={isEmpty}
                loading={loading}
                notifications={notifications.filter((f) => f.userType.toUpperCase() === currentTab.toUpperCase())}
                readNotification={readNotification}
                setSkip={setSkip}
                skip={skip}
                currentTab={currentTab}
              />

            </>
          )}
      </Popover>
    </>
  );
};

export default NotificationsPopover;
